// extracted by mini-css-extract-plugin
module.exports = {"columnsContainer":"Infos_columnsContainer__3we3O","rowsContainer":"Infos_rowsContainer__35GJm","sideBySide":"Infos_sideBySide__17Aoa"};